import React from "react";
import { AppBar, Toolbar, Button, Box } from "@mui/material";
import { styled } from "@mui/system";
import Logo from "../../assets/images/bjk-dernek-logo.png";
import { Link, useNavigate, useLocation } from "react-router-dom";

const GlassAppBar = styled(AppBar)(({ theme }) => ({
  backgroundColor: "rgb(255, 255, 255)",
  boxShadow: "0px 4prgb(255, 255, 255)0.2)",
  position: "fixed",
  top: 0,
  left: 0,
  right: 0,
  margin: "0px auto",
  zIndex: 99,
  borderRadius: "none",
  padding: "5px 20px",
  color: "#333",
  height: "70px",
  width: "100%"
}));

const GlassButton = styled(Button)(({ theme }) => ({
  backdropFilter: "blur(10px)",
  backgroundColor: "var(--black-primary)",
  color: "white",
  borderRadius: "20px",
  padding: "5px 20px",
  "&:hover": {
    backgroundColor: "var(--black-color)"
  }
}));

// First, define interface for the LinkButton props
interface LinkButtonProps {
  active?: boolean;
}

// Update the LinkButton styled component with proper typing
const LinkButton = styled(Button)<LinkButtonProps>(({ theme, active }) => ({
  color: active ? 'var(--white-color)' : 'var(--black-primary)',
  textTransform: 'capitalize',
  position: 'relative',
  padding: '8px 16px',
  overflow: 'hidden',
  textDecoration: 'none', // Remove underline
  '&::before': {
    content: '""',
    position: 'absolute',
    top: active ? '0' : '50%',
    left: 0,
    width: '100%',
    height: active ? '100%' : 0,
    backgroundColor: 'var(--black-primary)',
    transition: 'all 0.3s ease-in-out',
    zIndex: -1,
  },
  '&:hover': {
    color: 'var(--white-color)',
    textDecoration: 'none', // Remove underline on hover
    '&::before': {
      height: '100%',
      top: 0,
    },
    '& span': {
      color: 'var(--white-color)',
      transition: 'color 0.3s ease-in-out',
    }
  },
  '& span': {
    position: 'relative',
    zIndex: 1,
    color: active ? 'var(--white-color)' : 'inherit',
    textDecoration: 'none', // Remove underline from span
  }
}));

function Header() {
  const location = useLocation();
  const navigate = useNavigate();

  const handleTabClick = (path: string) => {
    navigate(path);
  };

  return (
    <GlassAppBar position='fixed'>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            overflow: "hidden",
            marginTop: "-20px",
            marginRight: "-100px"
          }}>
          <Link to='/' onClick={() => handleTabClick("/")}>
            <img
              src={Logo}
              alt='Besiktasli-doktorlar-dernegi-logo'
              width={300}
            />
          </Link>
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Link to='/' style={{ textDecoration: 'none' }}> {/* Remove underline from Link */}
            <LinkButton 
              onClick={() => handleTabClick("/")} 
              active={location.pathname === "/"}>
              <span className="B-18">Ana Sayfa</span>
            </LinkButton>
          </Link>
          <Link to='/hakkimizda' style={{ textDecoration: 'none' }}> {/* Remove underline from Link */}
            <LinkButton 
              onClick={() => handleTabClick("/hakkimizda")} 
              active={location.pathname === "/hakkimizda"}>
              <span className="B-18">Hakkımızda</span>
            </LinkButton>
          </Link>
          <Link to='/uyeler' style={{ textDecoration: 'none' }}> {/* Remove underline from Link */}
            <LinkButton 
              onClick={() => handleTabClick("/uyeler")} 
              active={location.pathname === "/uyeler"}>
              <span className="B-18">Üyelerimiz</span>
            </LinkButton>
          </Link>
          <Link to='/etkinlikler' style={{ textDecoration: 'none' }}> {/* Remove underline from Link */}
            <LinkButton 
              onClick={() => handleTabClick("/etkinlikler")} 
              active={location.pathname === "/etkinlikler"}>
              <span className="B-18">Etkinlikler</span>
            </LinkButton>
          </Link>
          <Link to='/kurullar' style={{ textDecoration: 'none' }}> {/* Remove underline from Link */}
            <LinkButton 
              onClick={() => handleTabClick("/kurullar")} 
              active={location.pathname === "/kurullar"}>
              <span className="B-18">Kurullar</span>
            </LinkButton>
          </Link>
          <Link to='/iletisim' style={{ textDecoration: 'none' }}> {/* Remove underline from Link */}
            <LinkButton 
              onClick={() => handleTabClick("/iletisim")} 
              active={location.pathname === "/iletisim"}>
              <span className="B-18">İletişim</span>
            </LinkButton>
          </Link>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <GlassButton
            variant='contained'
            onClick={() => handleTabClick("/uyelik")}>
            <span
              className={location.pathname === "/uyelik" ? "B-18-bold" : "B-18"}
              style={{
                color: "var(--white-color)",
                textTransform: "capitalize"
              }}>
              Üye Ol
            </span>
          </GlassButton>
        </Box>
      </Toolbar>
    </GlassAppBar>
  );
}

export default Header;
